import AdbDraggable from './src/adb-draggable.vue';

AdbDraggable.install = function (Vue) {
  Vue.component(AdbDraggable.name, AdbDraggable);
};

export default AdbDraggable;
